"use client"

import { Button } from "@/components/ui/button"
import { useAdminAuth } from "@/hooks/use-admin-auth"
import { LogOut, Wallet } from "lucide-react"

export function ConnectWallet() {
  const { walletAddress, authenticated, ready, login, logout } = useAdminAuth()

  if (!ready) {
    return (
      <Button variant="outline" disabled>
        Loading...
      </Button>
    )
  }

  if (!authenticated) {
    return (
      <Button onClick={login}>
        <Wallet className="mr-2 size-4" />
        Connect Wallet
      </Button>
    )
  }

  const shortAddress = walletAddress
    ? `${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`
    : ""

  return (
    <div className="flex items-center gap-3">
      <code className="rounded bg-muted px-2 py-1 text-sm">{shortAddress}</code>
      <Button variant="ghost" size="icon" onClick={logout}>
        <LogOut className="size-4" />
      </Button>
    </div>
  )
}
